import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IMassHolidays, IPeriod } from '@interfaces/IPeriod';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeriodsChangesService {
  constructor(private _http: HttpClient) {}

  create(period: IPeriod): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/`;
    return this._http.post<IPeriod>(url, period);
  }

  update(id: number, data: IPeriod): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/`;
    return this._http.put<IPeriod>(url, data);
  }

  addMassHolidays(data: IMassHolidays): Observable<IMassHolidays> {
    const url = `${environment.baseUrl}api/v1/holiday/`;
    return this._http.post<IMassHolidays>(url, data);
  }

  deleteHolidays(periodId: number): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${periodId}/rollback_holiday/`;
    return this._http.post<IPeriod>(url, periodId);
  }

  patchUpdate(id: number, data: IPeriod): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/`;
    return this._http.patch<IPeriod>(url, data);
  }

  putUpdate(id: number, data: IPeriod): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/`;
    return this._http.put<IPeriod>(url, data);
  }

  delete(id: number): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/`;
    return this._http.delete<IPeriod>(url);
  }

  setTheme(id: number, data: { theme: string }): Observable<IPeriod> {
    const url = `${environment.baseUrl}api/v1/periods/${id}/set-theme/`;
    return this._http.patch<IPeriod>(url, data);
  }
}
